import React, { useState } from "react";
import { Box } from "@mui/material";
import GerenciarAdminAdicionar from "../GerenciarAdminAdicionar";
import GerenciarAdminLista from "../GerenciarAdminLista";
import GerenciarSenha from "../GerenciarSenha"; // Importando o componente GerenciarSenha

interface GerenciarAdminProps {
  token: string;
  role: "MASTER" | "PARTNER" | "ANALYST";
}

const GerenciarAdmin: React.FC<GerenciarAdminProps> = ({ token, role }) => {
  const [shouldUpdateList, setShouldUpdateList] = useState<boolean>(false);

  const handleUpdateList = () => {
    setShouldUpdateList((prev) => !prev); // Altera o estado para forçar o re-fetch
  };

  return (
    <Box
      sx={{
        padding: 3,
        display: "flex",
        gap: "20px",
        flexWrap: "wrap",
        justifyContent: "space-between",
      }}
    >
      <Box sx={{ width: { xs: "100%", sm: "48%", md: "48%" } }}>
        <GerenciarAdminAdicionar
          token={token}
          role={role}
          onAdminAdded={handleUpdateList}
        />
      </Box>
      <Box sx={{ width: { xs: "100%", sm: "48%", md: "48%" } }}>
        <GerenciarSenha token={token} />{" "}
        {/* Renderiza GerenciarSenha se o role for MASTER */}
      </Box>
      <Box sx={{ width: { xs: "100%", sm: "100%", md: "100%" } }}>
        <GerenciarAdminLista
          token={token}
          role={role}
          shouldUpdateList={shouldUpdateList}
        />
      </Box>
    </Box>
  );
};

export default GerenciarAdmin;
